import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-066d8899")

_pushScopeId("data-v-066d8899")
const _hoisted_1 = { class: "buttons" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "el-icon-setting" }, null, -1)
const _hoisted_3 = { class: "text-left" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("编辑 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 添加同级分类 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("添加子类")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("删除")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_popover = _resolveComponent("el-popover")
  const _component_el_tree = _resolveComponent("el-tree")
  const _component_category_form = _resolveComponent("category-form")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_input, {
      placeholder: "输入关键字进行过滤",
      modelValue: _ctx.filterText,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterText = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_el_tree, {
      class: "filter-tree",
      data: _ctx.treeData,
      props: _ctx.defaultProps,
      "default-expand-all": "",
      "filter-node-method": _ctx.filterNode,
      "expand-on-click-node": false,
      onNodeClick: _ctx.handleNodeClick,
      ref: "tree"
    }, {
      default: _withId(({ node, data }) => [
        _createVNode("div", {
          class: {'custom-tree-node': true, 'is-current': data.id === _ctx.currentKey}
        }, [
          _createVNode("div", null, _toDisplayString(`${data.name}(${data.code})`), 1),
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_el_popover, {
              placement: "left-start",
              width: 120,
              trigger: "hover"
            }, {
              reference: _withId(() => [
                _hoisted_2
              ]),
              default: _withId(() => [
                _createVNode("div", _hoisted_3, [
                  (data.id !== 0)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        class: "block",
                        type: "text",
                        onClick: _withModifiers(($event: any) => (_ctx.editCategory(data, node.parent.data)), ["stop"])
                      }, {
                        default: _withId(() => [
                          _hoisted_4
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (data.id !== 0)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        class: "block",
                        type: "text",
                        onClick: _withModifiers(($event: any) => (_ctx.addCategory(node.parent.data)), ["stop"])
                      }, {
                        default: _withId(() => [
                          _hoisted_5
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_button, {
                    class: "block",
                    type: "text",
                    onClick: _withModifiers(($event: any) => (_ctx.addCategory(data)), ["stop"])
                  }, {
                    default: _withId(() => [
                      _hoisted_6
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  (data.id !== 0 && (!data.children || data.children.length === 0))
                    ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                        key: 2,
                        class: "block",
                        onConfirm: ($event: any) => (_ctx.deleteCategory(data)),
                        title: "确定删除吗？"
                      }, {
                        reference: _withId(() => [
                          _createVNode(_component_el_button, { type: "text" }, {
                            default: _withId(() => [
                              _hoisted_7
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["onConfirm"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 2
            }, 1024)
          ])
        ], 2)
      ]),
      _: 1
    }, 8, ["data", "props", "filter-node-method", "onNodeClick"]),
    _createVNode(_component_el_dialog, {
      title: _ctx.categoryEditMode === 'ADD' ? '创建分类' : '编辑分类' ,
      modelValue: _ctx.categoryDialogVisible,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.categoryDialogVisible = $event)),
      width: "40%"
    }, {
      default: _withId(() => [
        _createVNode(_component_category_form, {
          categoryType: _ctx.categoryType,
          category: _ctx.currentNode,
          parentCategory: _ctx.currentParentNode,
          editMode: _ctx.categoryEditMode,
          onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.categoryDialogVisible = false)),
          onSuccess: _ctx.categoryUpdated
        }, null, 8, ["categoryType", "category", "parentCategory", "editMode", "onSuccess"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ], 64))
})